var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from './framework/Timeouts';
export class LibertyAvDLE {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`/^Version`, /^V(.+)/i, tags);
                return match[1];
            }),
            powerOffRestrictions: ['get'],
        };
        // Commenting out power off for Stephane Villeneuve Quebec convention center project because
        // he's sending IR commands through the switcher and due to the delay of powering up the
        // switcher, his TVs don't power on the first time and he has to wait 15 seconds and power the
        // TVs on manually.
        //
        // This is the room: https://mira.aveosystems.com/#!/dashboard/all?roomId=-MUsic3xBZJ9qNrqRmUr
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`STA`, /^Power (ON|OFF)!/i, tags);
                return match[1] === 'ON';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                if (!power)
                    return this.state.power.value; // Don't turn off device.
                const match = yield this.socket.send(`${power ? 'PowerON' : 'PowerOFF'}`, /^Power (ON|OFF)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 3000 : 1000);
                this.framework.suspend(power ? 2000 : 1000);
                return match[1] === 'ON';
            }),
            asyncHandlers: {
                regExp: /^Power (ON|OFF)!/i,
                callback: (match) => {
                    this.state.power.update(match[1] === 'ON');
                },
            },
            powerOffRestrictions: ['get'],
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`STA_VIDEO`, /Output(\d+) Switch To (\d+)!/i, tags);
                return parseInt(match[2], 10).toString(); // remove leading zeros
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`OUT${key}:${value}`, /Output(\d+) Switch To (\d+)!/i, tags);
                return parseInt(match[2], 10).toString(); // remove leading zeros
            }),
            asyncHandlers: {
                regExp: /Output(\d+) Switch To (\d+)!/i,
                callback: (match) => {
                    const key = match[1];
                    const value = parseInt(match[2], 10).toString();
                    this.state.videoMatrixRoutes.update(key, value);
                },
            },
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 5000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    if (this.state.power.value === true) {
                        yield this.socket.sendAsync(`STA_VIDEO`, ['poll']);
                    }
                }),
            },
        ];
    }
}
// static properties
LibertyAvDLE.driverType = 'socketDriver';
LibertyAvDLE.key = '-MUtghIHOu29nO4Zvavf';
LibertyAvDLE.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '.',
};
LibertyAvDLE.socketOptions = [
    Object.assign(Object.assign({}, LibertyAvDLE.baseSocketOptions), { idleTimeoutMs: 0, port: 4001 }),
    Object.assign(Object.assign({}, LibertyAvDLE.baseSocketOptions), { port: 4999 }),
];
